import { Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const CheckoutLeft = ({ selectedProduct, quantity }) => {
  const [selectedPrice, setSelectedPrice] = useState({});
  const [allPrices, setAllPrices] = useState([]);
  const { pid, priceIdx } = useParams();
  const navigate = useNavigate();
  const { productInfo = [] } = selectedProduct;
  useEffect(() => {
    setSelectedPrice(productInfo[parseInt(priceIdx)] || {});
    setAllPrices(productInfo);
  }, [productInfo, priceIdx]);
  return (
    <div
      className={`bg-front dark:dark-bg-front border shadow-lg  rounded-lg p-4 mb-8 col-span-full sm:col-span-6  md:col-span-8`}
    >
      {/* Selected Product Image */}
      {/* <div className="my-8">
        <img
          className="aspect-video"
          src={selectedProduct?.photo}
          alt={selectedProduct?.name}
        />
      </div> */}
      {/* Selected Product Info */}
      <div className="my-8">
        <h1 className="text-3xl font-bold mb-2 nav-item  cursor-pointer inline-block">
          Product Informations : ({selectedProduct?.name})
        </h1>
        <table className="w-full md:w-8/12   font-sans text-sm my-3">
          <tbody className="font-medium text-lg">
            <tr className="border-b border-b-gray-500 border-opacity-50">
              <td className="py-5">Product</td>
              <td className="py-5">:</td>
              <td className="text-right py-5">{selectedPrice?.title}</td>
            </tr>
            <tr className="border-b border-b-gray-500 border-opacity-50">
              <td className="py-5">Product Price</td>
              <td className="py-5">:</td>
              <td className="text-right py-5">
                {selectedPrice?.price} <span className="text-xl">&#2547;</span>
              </td>
            </tr>
            <tr className="border-b border-b-gray-500 border-opacity-50">
              <td className="py-5">Maximum Delivary Time</td>
              <td className="py-5">:</td>
              <td className="text-right py-5">10 min</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Other Products */}
      {allPrices.length > 0 && (
        <div className="my-8">
          <h1 className="text-3xl font-bold mb-2 nav-item  cursor-pointer inline-block">
            Other Options of Same Products :
          </h1>
          <div className="w-full grid grid-cols-12 gap-3 ">
            {allPrices.map((pinf, i) => {
              return (
                i !== parseInt(priceIdx) && (
                  <Tooltip
                    key={i}
                    title={<span>{pinf.price} &#2547;</span>}
                    arrow
                  >
                    <button
                      onClick={() =>
                        navigate("/products/" + pid + "/checkout/" + i)
                      }
                      className={` ring-2 my-1  md:col-span-3 ring-gray-500 rounded py-5 px-7 cursor-pointer  hover:ring-orange-500 `}
                      key={i}
                    >
                      <h1 className="text-xl ">{pinf.title}</h1>
                      <p className="font-bold text-brand">
                        {pinf.price} &#2547;
                      </p>
                      <p className="text-sm">Stock {pinf.stock}</p>
                    </button>
                  </Tooltip>
                )
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CheckoutLeft;
